// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121035/js/" + chunkId + "." + {"44":"6f0535dc","225":"bbea15ad","481":"1c0235df","486":"28b6e6b3","770":"67c7f399"}[chunkId] + ".0.9555854230748856.chunk.js";
};